"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _reactFinalForm = require("react-final-form");

var _reactI18next = require("react-i18next");

var _rcSelect = _interopRequireDefault(require("rc-select"));

var _withFieldWrapper = _interopRequireDefault(require("../hocs/withFieldWrapper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = {
  "formWrapper": "index__formWrapper",
  "formBtn": "index__formBtn",
  "formBtnCancel": "index__formBtnCancel",
  "formLink": "index__formLink",
  "withoutOpd": "index__withoutOpd",
  "formLabel": "index__formLabel",
  "formLabelRequired": "index__formLabelRequired",
  "formLabelOptional": "index__formLabelOptional",
  "formInput": "index__formInput",
  "formTextarea": "index__formTextarea",
  "formSection": "index__formSection",
  "formSectionRow": "index__formSectionRow",
  "formSectionBtn": "index__formSectionBtn",
  "error": "index__error",
  "compositeError": "index__compositeError",
  "fileInput": "index__fileInput",
  "fileControls": "index__fileControls",
  "formDateSelect": "index__formDateSelect",
  "formMoneySelect": "index__formMoneySelect",
  "amountField": "index__amountField",
  "currencyField": "index__currencyField",
  "imagePreview": "index__imagePreview",
  "dangerBtn": "index__dangerBtn",
  "dangerBtnDisabled": "index__dangerBtnDisabled",
  "fileList": "index__fileList",
  "fileItem": "index__fileItem",
  "downloadButton": "index__downloadButton",
  "downloadButtonDisabled": "index__downloadButtonDisabled",
  "fileButtonGroup": "index__fileButtonGroup",
  "timeIndicator": "index__timeIndicator",
  "modalButtonGroup": "index__modalButtonGroup"
};
var customStyle = {
  control: function control(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      minHeight: '36px',
      height: '36px'
    });
  }
};

var Money = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Money, _Component);

  var _super = _createSuper(Money);

  function Money(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Money);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getOptions", function () {
      var _this$props = _this.props,
          settings = _this$props.settings,
          _this$props$options = _this$props.options,
          options = _this$props$options === void 0 ? [] : _this$props$options;

      if (!(0, _ramda.isEmpty)(options)) {
        var currency = (0, _ramda.prop)('currency', settings);
        var availableCurrencies = (0, _ramda.prop)('availableCurrencies', settings);
        var currencyArray = currency ? [currency] : availableCurrencies;
        return currencyArray.map(function (currencyId) {
          var currencyItem = (0, _ramda.find)((0, _ramda.propEq)('value', currencyId), options);
          return {
            value: currencyItem.label,
            label: currencyItem.label
          };
        });
      } else {
        return [];
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSingleCurrency", function () {
      var _this$props2 = _this.props,
          settings = _this$props2.settings,
          _this$props2$options = _this$props2.options,
          options = _this$props2$options === void 0 ? [] : _this$props2$options,
          required = _this$props2.required,
          input = _this$props2.input;

      if (!(0, _ramda.isEmpty)(options) && (required || (0, _ramda.prop)('amount', input.value))) {
        var currency = (0, _ramda.prop)('currency', settings);

        if (currency) {
          var currencyItem = (0, _ramda.find)((0, _ramda.propEq)('value', currency), options);
          return currencyItem.label;
        } else {
          return undefined;
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeAmount", function (onChange) {
      return function (event) {
        var value = event.target.value;
        onChange(value ? Number(value) : undefined);
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeCurrency", function (onChange) {
      return function (value) {
        onChange(value);
      };
    });
    _this.selectContainer = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(Money, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var getDictionary = this.props.getDictionary;
      var urlParams = "?pagination=".concat(encodeURI('{"offset": 0,"limit": 0 }'));
      getDictionary('currency', 'items', urlParams, {
        labelPath: 'code',
        valuePath: 'id'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          name = _this$props3.input.name,
          t = _this$props3.t,
          disabled = _this$props3.disabled;
      var options = this.getOptions();
      var singleCurrency = this.getSingleCurrency();
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "".concat(name, "-money"),
        className: "jobot-forms__formMoneySelect ".concat(styles.formMoneySelect)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: styles.amountField
      }, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
        name: "".concat(name, ".amount"),
        key: name
      }, function (_ref) {
        var _ref$input = _ref.input,
            value = _ref$input.value,
            onChange = _ref$input.onChange;
        return /*#__PURE__*/_react["default"].createElement("input", {
          id: name,
          disabled: disabled,
          type: "number",
          className: styles.formInput,
          value: value,
          onChange: _this2.onChangeAmount(onChange),
          placeholder: null
        });
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: styles.currencyField,
        ref: this.selectContainer
      }, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
        key: "".concat(name, "-").concat(singleCurrency),
        name: "".concat(name, ".currency"),
        initialValue: singleCurrency
      }, function (_ref2) {
        var _ref2$input = _ref2.input,
            value = _ref2$input.value,
            onChange = _ref2$input.onChange;
        return /*#__PURE__*/_react["default"].createElement(_rcSelect["default"], {
          id: "".concat(name, "-currency"),
          styles: customStyle,
          disabled: singleCurrency && value || disabled,
          value: value || singleCurrency,
          options: options,
          onChange: _this2.onChangeCurrency(onChange),
          notFoundContent: t('noOptionsMessage'),
          placeholder: t('placeholders.salaryCurrency'),
          prefixCls: "jobot-forms-rc-select",
          getPopupContainer: function getPopupContainer() {
            return _this2.selectContainer.current;
          }
        });
      })));
    }
  }]);
  return Money;
}(_react.Component);

var _default = (0, _withFieldWrapper["default"])((0, _reactI18next.withTranslation)()(Money));

exports["default"] = _default;